import type { Cours } from '../../lib/useCours';

/** Programme d'un cours archivé : affiché tel quel, rien ne se déplace ni ne se modifie. */
export function ProgrammeEnLecture({ cours }: { cours: Cours }): JSX.Element {
  if (cours.modules.length === 0) {
    return <p className="rounded-xl bg-gray-50 px-4 py-3 text-sm text-codialis-gray">Le programme est vide.</p>;
  }
  return (
    <ol className="space-y-3">
      {cours.modules.map((module, index) => (
        <li key={module.id} className="rounded-xl border border-gray-100 bg-white">
          <div className="flex items-center gap-3 p-2 sm:p-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-codialis-sky text-xs font-bold text-white">
              {index + 1}
            </div>
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-semibold text-codialis-navy">{module.titre}</div>
              <div className="text-xs text-codialis-gray">
                {module.lecons.length === 0
                  ? 'Aucune leçon'
                  : module.lecons.length === 1
                    ? '1 leçon'
                    : `${module.lecons.length} leçons`}
              </div>
            </div>
          </div>
          {module.lecons.length > 0 && (
            <ol className="space-y-2 px-2 pb-2 sm:px-3 sm:pb-3">
              {module.lecons.map((lecon, rang) => (
                <li key={lecon.id} className="flex items-center gap-2 rounded-lg bg-gray-50 p-2">
                  <span className="w-8 shrink-0 font-mono text-xs text-codialis-gray">
                    {index + 1}.{rang + 1}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-sm font-medium text-codialis-navy">{lecon.titre}</span>
                </li>
              ))}
            </ol>
          )}
        </li>
      ))}
    </ol>
  );
}
